import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { TimelineSelect } from 'components/TimelineSelect/TimelineSelect';
import { QuickSearch } from 'screens/Team/Rabbit/Goals/AgGridTreeView/QuickSearch';
import { ExpandCollapseAll } from 'screens/Team/Rabbit/Goals/AgGridTreeView/components/ExpandCollapseAll';

interface Props {
  gridRef: any;
  localSelectedTimePeriod: any;
  setLocalSelectedTimePeriod: any;
}

const Header = ({ gridRef, localSelectedTimePeriod, setLocalSelectedTimePeriod }: Props) => (
  <Flex alignItems="center" justifyContent="space-between" px={2} py={3}>
    <Box flex={1} minW="180px" maxW="100%">
      <QuickSearch gridRef={gridRef} selectedCohort={null} placeholder="Search Goals" maxWidth="100%" isV2 />
    </Box>

    <Flex justifyContent="flex-end">
      <Box>
        <ExpandCollapseAll defaultExpandAll gridRef={gridRef} />
      </Box>
      <TimelineSelect selectedTimeline={localSelectedTimePeriod} onSelect={setLocalSelectedTimePeriod} />
    </Flex>
  </Flex>
);

export default Header;
